import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react';
import { Form, Row } from 'antd';
import { FieldData } from 'rc-field-form/es/interface';
import { IAntDFormChangeFieldName, IEditForm, IFormFields, IZoneInfo } from '../../../interfaces';
import {
    apiMessagesDeleteMessageByFieldName,
    apiMessagesGetFormRulesNoBlankAndMinMax,
    apiMessagesSaveMessages,
    apiMessagesSaveMessagesV2,
} from '../../../middleware';
import { patchZone } from '../../../middleware';
import { cleanPathFields } from '../../../instruments';
import { tF } from '../../../translate';
import { CardInfoToolBar, CardMainLayout, Catcher, InputDebounce } from '../../../Components';
import Styles from '../../styles/m_itemCardStyles.less';

interface IEditZoneForm extends IEditForm {
    initialValues: IZoneInfo;
}

export const EditZoneForm: React.FC<IEditZoneForm> = observer(({ initialValues, setEditMode }: IEditZoneForm) => {
    const [form] = Form.useForm();
    const isNew = !initialValues.id;
    const [isSending, setSending] = useState(false);
    const [isChanged, setChanged] = useState(false);

    useEffect(() => {
        if (!isChanged) {
            form.setFieldsValue(initialValues);
        }
    }, [initialValues]);

    const onFieldsChange = (changedFields: FieldData[]): void => {
        const fieldNameChange =
            changedFields && changedFields[0] && (changedFields[0].name as IAntDFormChangeFieldName);
        if (fieldNameChange) {
            apiMessagesDeleteMessageByFieldName(fieldNameChange);
        }

        setChanged(true);
    };

    const onFinish = async (fields: IFormFields): Promise<void> => {
        setSending(true);
        const cleanFields = cleanPathFields(fields, initialValues);
        const { isError, errors } = await patchZone(initialValues.id, cleanFields);

        if (isError) {
            if (Array.isArray(errors)) {
                apiMessagesSaveMessages(errors);
            } else {
                apiMessagesSaveMessagesV2(errors);
            }
            form.validateFields();
        } else {
            setEditMode && setEditMode(false);
        }
        setSending(false);
    };

    const nameTitle = tF('Name');

    return (
        <Catcher>
            <article className={Styles.main}>
                <Row>
                    <CardMainLayout idSpinners={['GET_ZONE']} isEdit name={initialValues.name}>
                        <Form
                            form={form}
                            name="zoneInfo"
                            initialValues={initialValues}
                            onFieldsChange={onFieldsChange}
                            onFinish={onFinish}
                            scrollToFirstError={true}
                            layout={'vertical'}
                        >
                            <Form.Item
                                name="name"
                                label={nameTitle}
                                rules={apiMessagesGetFormRulesNoBlankAndMinMax(3, 256)}
                            >
                                <InputDebounce placeholder={nameTitle} isFirstInput />
                            </Form.Item>
                            <CardInfoToolBar isLoading={isSending} isNew={isNew} isSubmitButton />
                        </Form>
                    </CardMainLayout>
                </Row>
            </article>
        </Catcher>
    );
});
